import OvrI18n from './Ovr.i18n.js';

export default {

  components: {},

  props: {},

  data() {
    return {};
  },

  watch: {},

  methods: {},

  mounted() {},

  i18n: OvrI18n,

};



// WEBPACK FOOTER //
// ./src/views/Ovr/Ovr.js